import React, { useEffect, useState } from 'react'

const ProviderHistoryofdiagnosisTs = ({ diagnosis, diagnosisName, showDataIfNoteIsFollowUp, patientID, noteID, isAllotedToProvider, patientDiagnosis, noteStructureRef }) => {
  const [allQuestions, setAllQuestions] = useState([])
  useEffect(() => {
    if (noteStructureRef.current && noteStructureRef.current.historyOfDiagnosis && noteStructureRef.current.historyOfDiagnosis[diagnosisName]) {
      setAllQuestions(noteStructureRef.current.historyOfDiagnosis[diagnosisName])
    } else {
      setAllQuestions([])
    }
  }, [noteStructureRef.current, diagnosisName])

  return (
    <div>
      {allQuestions && allQuestions.length > 0 ? (
        allQuestions.map((question, index) => (
          <div key={index}>
            <p>
              {question?.label}: <strong>{question?.answer ? question?.answer?.split('|||')?.join(', ') : 'No Answer'} </strong>
              {question?.freeType && <span>"{question?.freeType}"</span>}
            </p>
          </div>
        ))
      ) : (
        <p className="text-secondary">No history of diagnosis available.</p>
      )}
    </div>
  )
}

export default ProviderHistoryofdiagnosisTs
